import { render, staticRenderFns } from "./GroupMemberPopoverList.vue?vue&type=template&id=109d30ea&scoped=true&"
import script from "./GroupMemberPopoverList.vue?vue&type=script&lang=ts&"
export * from "./GroupMemberPopoverList.vue?vue&type=script&lang=ts&"
import style0 from "./GroupMemberPopoverList.vue?vue&type=style&index=0&id=109d30ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109d30ea",
  null
  
)

export default component.exports